import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import PublicFooter from '@/components/App/Footer/PublicFooter.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {


const authStore = useStore.auth;


return (_ctx: any,_cache: any) => {
  return (!_unref(authStore).user)
    ? (_openBlock(), _createBlock(PublicFooter, { key: 0 }))
    : _createCommentVNode("", true)
}
}

})